export { default } from './SearchRecent';
